import { motion } from "framer-motion";
import { Facebook, Quote, Award } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

const testimonial = {
  name: "Dr. Euler Bentes",
  role: "Data Scientist",
  content:
    "The Silva Labs training platform is exceptional! Dr. Silva is an outstanding professional and mentor — his hands-on approach makes complex AI topics easy to understand. Highly recommended!",
  certificates: 1,
};

export const SocialProof = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-primary bg-clip-text text-transparent"
          >
            {t("socialProof.title")}
          </motion.h2>

          {/* Facebook Community */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex items-center justify-center gap-4 mb-8"
          >
            <div className="flex items-center gap-3 p-4 rounded-2xl bg-card/30 backdrop-blur-xl border border-white/10">
              <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
                <Facebook className="w-6 h-6 text-blue-500" />
              </div>
              <div className="text-left">
                <div className="text-3xl font-bold text-foreground">4K+</div>
                <div className="text-sm text-muted-foreground">{t("socialProof.followersOnFacebook")}</div>
              </div>
            </div>
            <Button
              variant="outline"
              className="gap-2"
              onClick={() => window.open("https://facebook.com/aicavite", "_blank")}
            >
              <Facebook className="w-4 h-4" />
              {t("socialProof.joinCommunity")}
            </Button>
          </motion.div>
        </div>

        {/* Single Testimonial */}
        <div className="max-w-2xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <Card className="bg-card/30 backdrop-blur-xl border-white/10 hover:shadow-glass-hover transition-all duration-300">
              <CardContent className="p-8">
                <Quote className="w-12 h-12 text-primary/40 mb-6" />
                <p className="text-foreground text-lg mb-8 italic leading-relaxed">"{testimonial.content}"</p>
                <div className="flex items-center justify-between pt-6 border-t border-white/10">
                  <div>
                    <div className="font-bold text-foreground text-lg">{testimonial.name}</div>
                    <div className="text-muted-foreground">{testimonial.role}</div>
                  </div>
                  <div className="flex items-center gap-2 text-primary">
                    <Award className="w-6 h-6" />
                    <span className="text-lg font-semibold">
                      {testimonial.certificates} {t("socialProof.certs")}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
